import {useField} from 'formik';
import {useCallback} from 'react';

import {Toggle, ToggleProps} from './Toggle';

type Props = {
    name: string;
} & Partial<ToggleProps>;

export const ToggleFormik: React.FC<Props> = ({name, ...rest}: Props) => {
    const [field,, helpers] = useField(name);
    const handleChange = useCallback((checked: boolean) => {
        helpers.setValue(checked);
    }, [helpers]);

    return (
        <Toggle {...rest} name={name} checked={field.value} onChange={handleChange} />
    );
};
